import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "burger-menu",
  "use": "burger-menu-usage",
  "viewBox": "0 0 26 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 20\" id=\"burger-menu\">\r\n  <path d=\"M1.59,17a1.48,1.48,0,1,0,0,3H24.41a1.48,1.48,0,1,0,0-3Zm0-8.15A1.54,1.54,0,0,0,0,10.37a1.54,1.54,0,0,0,1.59,1.48H24.41A1.54,1.54,0,0,0,26,10.37a1.54,1.54,0,0,0-1.59-1.48ZM1.59,0A1.54,1.54,0,0,0,0,1.48,1.54,1.54,0,0,0,1.59,3H24.41A1.54,1.54,0,0,0,26,1.48,1.54,1.54,0,0,0,24.41,0Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol